export type Credentials = {
    email: string;
    password: string;
};

export type LegacyCredentials = {
    code: string;
    password: string;
};

export type SignupPayload = {
    email: string;
    firstName?: string;
    lastName?: string;
    avatar?: string | null;
    phone?: string | null;
    externalId?: string;
};

export type SignupResponse = {
    firstName: string;
};

export type LoginResponse = {
    accessToken: string;
    refreshToken: string;
};

export type VerifyEmailResponse = {
    success: boolean;
};

export type SendRecoveryEmailResponse = {
    success: boolean;
};

export type PlatformRedirectResponse = {
    success: boolean;
    nextPage?: string;
    error?: string;
    errorCode?: string;
};

export type RedirectUrlResponse = {
    url: string;
};

export type RefreshTokenResponse = {
    accessToken: string;
    refreshToken: string;
};

export type Organization = {
    name: string;
    externalId: string;
    id: string;
    photo?: string;
};
export type ChangePasswordApiArg = {
    newPassword: string;
};
export type ChangePasswordApiResponse = {
    success?: boolean;
};

export type GetIdpResponse = {
    uid?: string;
    email?: string;
    emailVerified?: boolean;
    displayName?: string;
    photoURL?: string;
    disabled?: boolean;
    metadata?: {
        lastSignInTime: string;
        creationTime: string;
        lastRefreshTime: string;
    };
    tokensValidAfterTime?: string;
    providerData?: ProviderData[];
};
export type ProviderData = {
    uid: string;
    displayName: string;
    email: string;
    photoURL: string;
    providerId: 'google.com' | 'password';
};
